"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DesignFileAi1: ['design-file-ai-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M7,12.125A.876.876,0,0,0,6.128,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.877.877,0,0,0,7,12.125Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM9.128,17.5a.625.625,0,0,1-1.25,0V15.375a.25.25,0,0,0-.25-.25H6.378a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.125a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,9.128,13Zm3.247-.625H12.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,1,1,0-1.25h.125a.249.249,0,0,0,.25-.249V12.377a.252.252,0,0,0-.253-.252H10.5a.625.625,0,1,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.126a.248.248,0,0,0-.249.249v4.249A.252.252,0,0,0,12.375,16.875Z']],
  DesignFileAi: ['design-file-ai', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M10,13.125A.877.877,0,0,0,9.125,14v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14A.877.877,0,0,0,10,13.125Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM12.125,18.5a.625.625,0,0,1-1.25,0V16.375a.25.25,0,0,0-.25-.25H9.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V14.125a2.213,2.213,0,0,1,1.9-2.239A2.128,2.128,0,0,1,12.125,14Zm3.247-.625H15.5a.625.625,0,1,1,0,1.25h-2a.625.625,0,1,1,0-1.25h.126a.249.249,0,0,0,.249-.249V13.377a.252.252,0,0,0-.252-.252H13.5a.625.625,0,1,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.126a.248.248,0,0,0-.249.249v4.249A.252.252,0,0,0,15.372,17.875Z']],
  DesignFilePenAlternate: ['design-file-pen-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.992,13.811a4.705,4.705,0,0,1-3.307-3.3.251.251,0,0,0-.27-.186,5.5,5.5,0,0,0-4.54,3.822l-1.353,4.42A1.126,1.126,0,0,0,6.59,20.033a1.085,1.085,0,0,0,.341-.054l4.424-1.354a5.5,5.5,0,0,0,3.823-4.544A.25.25,0,0,0,14.992,13.811ZM11.4,15.862a1.246,1.246,0,1,1,0-1.762A1.246,1.246,0,0,1,11.4,15.862Z', 'M14.668,6.866a.5.5,0,0,0-.707,0,3.3,3.3,0,0,0,4.674,4.673.5.5,0,0,0,0-.707Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.536A.5.5,0,0,1,20,7.035Z']],
  DesignFilePyramidAlternate: ['design-file-pyramid-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,16.286c-2.6,0-4.544.919-4.544,1.741S9.4,19.77,12,19.77s4.544-.92,4.544-1.743S14.6,16.286,12,16.286Z', 'M8.383,15.931A9.438,9.438,0,0,1,12,15.286a9.447,9.447,0,0,1,3.625.648.245.245,0,0,0,.317-.328L12.281,7.065a.248.248,0,0,0-.456-.006C11.1,8.71,8.85,13.822,8.067,15.6A.245.245,0,0,0,8.383,15.931Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.536A.5.5,0,0,1,20,7.035Z']],
  DesignFileTextAlternate: ['design-file-text-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.5,7h-7A1.5,1.5,0,0,0,7,8.5V10a1,1,0,0,0,2,0V9.25A.25.25,0,0,1,9.25,9h1.5a.25.25,0,0,1,.25.25v6a.25.25,0,0,1-.25.25H10a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2h-.75a.25.25,0,0,1-.25-.25v-6A.25.25,0,0,1,13.25,9h1.5a.25.25,0,0,1,.25.25V10a1,1,0,0,0,2,0V8.5A1.5,1.5,0,0,0,15.5,7Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.536A.5.5,0,0,1,20,7.035Z']],
  DesignFileVectorAlternate: ['design-file-vector-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.3,10.1c.177-.177.519-.1.7-.1a2,2,0,0,0,2-2h0a2,2,0,1,0-4,0c0,.173.07.481-.1.668L8.156,13.416c-.194.194-.483.085-.656.085a2,2,0,1,0,2,2h0c0-.182-.113-.489.087-.689Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.354.146l4.535,4.536A.5.5,0,0,1,20,7.035Z', 'M16.917,11.5H15.749a4.336,4.336,0,0,0-4.332,4.332V17.5a1,1,0,0,0,2,0V15.832A2.334,2.334,0,0,1,15.749,13.5h1.168a1,1,0,0,0,0-2Z']],
  DesignDocumentDwg1: ['design-document-dwg-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.437,12.257a.252.252,0,0,0-.312.246V18.5a.251.251,0,0,0,.312.246,3.376,3.376,0,0,0,0-6.486Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM3.5,20.125a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25Zm12.625-6.041c0,2.692-.6,4.772-1.683,5.858a.625.625,0,0,1-1.045-.277s-.675-2.426-.724-2.657-.283-.229-.346,0-.724,2.657-.724,2.657a.625.625,0,0,1-1.045.277c-1.085-1.086-1.683-3.166-1.683-5.858V11.5a.625.625,0,0,1,1.25,0v2.584a13.2,13.2,0,0,0,.354,3.07c.133.3.42.341.513,0l.9-3.319a.625.625,0,0,1,1.206,0s.842,3.073.9,3.319.364.377.513,0a12.827,12.827,0,0,0,.354-3.07V11.5a.625.625,0,0,1,1.25,0ZM19.5,18.875A1.377,1.377,0,0,0,20.875,17.5v-.124a.251.251,0,0,0-.251-.251H20a.625.625,0,0,1,0-1.25h1.5a.625.625,0,0,1,.625.625v1a2.625,2.625,0,0,1-5.25,0v-4a2.625,2.625,0,0,1,5.25,0,.625.625,0,0,1-1.25,0,1.375,1.375,0,0,0-2.75,0v4A1.377,1.377,0,0,0,19.5,18.875Z']],
  DesignDocumentDxf: ['design-document-dxf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.456,9.819a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,7.875,12,2.238,2.238,0,0,0,6.456,9.819Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM5.5,15.625A.625.625,0,0,1,4.875,15V9A.625.625,0,0,1,5.5,8.375a3.625,3.625,0,0,1,0,7.25Zm8.559-.9a.625.625,0,1,1-1.118.558s-.859-1.7-.879-1.759-.1-.043-.127.006l-.876,1.753a.625.625,0,1,1-1.118-.558l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.826,1.644.854,1.709a.1.1,0,0,0,.177-.006l.851-1.7a.625.625,0,1,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm4.441-5.1h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H17.5a.625.625,0,0,1,0,1.25H16.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10A1.626,1.626,0,0,1,16.5,8.375h2a.625.625,0,0,1,0,1.25Z']],
  DesignDocumentAi: ['design-document-ai', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,9.625a.876.876,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.877.877,0,0,0,10,9.625Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM12.128,15a.625.625,0,0,1-1.25,0V12.875a.25.25,0,0,0-.25-.25H9.378a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.625a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,12.128,10.5Zm3.247-.625H15.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.126a.248.248,0,0,0,.249-.249V9.877a.252.252,0,0,0-.252-.252H13.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25h-.125a.249.249,0,0,0-.25.249v4.249A.252.252,0,0,0,15.375,14.375Z']],
  DesignDocumentAi1: ['design-document-ai-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,12.125A1.377,1.377,0,0,0,8.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,9.5,12.125Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM12.125,19.5a.625.625,0,0,1-1.25,0V16.375a.25.25,0,0,0-.25-.25H8.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V13.6a2.7,2.7,0,0,1,2.1-2.678A2.629,2.629,0,0,1,12.125,13.5Zm5.375-.625a.625.625,0,0,1,0,1.25h-4a.625.625,0,0,1,0-1.25h1.125a.25.25,0,0,0,.25-.25v-6.25a.25.25,0,0,0-.25-.25H13.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25H16.375a.25.25,0,0,0-.25.25v6.25a.25.25,0,0,0,.25.25Z']],
  DesignDocumentMax: ['design-document-max', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9.625a.877.877,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V10.5A.877.877,0,0,0,12,9.625Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM9.125,15a.625.625,0,0,1-1.25,0V11.825c0-.075-.08-.063-.109,0s-.207.457-.207.457a.65.65,0,0,1-1.118,0s-.167-.327-.2-.4-.118-.062-.118.009V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s.807,1.606.837,1.673a.124.124,0,0,0,.208,0c.041-.083.837-1.674.837-1.674A.625.625,0,0,1,9.125,9Zm5,0a.625.625,0,0,1-1.25,0V12.875a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10.625a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,14.125,10.5Zm4.934-.279a.625.625,0,1,1-1.118.558s-.839-1.68-.876-1.753a.069.069,0,0,0-.129,0l-.877,1.754a.625.625,0,0,1-.559.346.615.615,0,0,1-.279-.066.624.624,0,0,1-.28-.838l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.851,1.7.876,1.753a.07.07,0,0,0,.129,0l.877-1.754a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Z']],
  DesignDocumentOtf: ['design-document-otf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,9.625a.877.877,0,0,0-.875.875v3a.875.875,0,0,0,1.75,0v-3A.877.877,0,0,0,7,9.625Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-13.375,9a2.125,2.125,0,0,1-4.25,0v-3a2.125,2.125,0,0,1,4.25,0ZM14.5,9.625H13.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9.875a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H18.5a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10A1.626,1.626,0,0,1,17.5,8.375h2a.625.625,0,0,1,0,1.25Z']],
  DesignDocumentOtf1: ['design-document-otf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,12.125A1.377,1.377,0,0,0,5.125,13.5v4a1.375,1.375,0,0,0,2.75,0v-4A1.377,1.377,0,0,0,6.5,12.125Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.125,17.5a2.625,2.625,0,0,1-5.25,0v-4a2.625,2.625,0,0,1,5.25,0ZM14.5,12.125H13.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H18a.875.875,0,0,0-.875.875v1.625a.25.25,0,0,0,.25.25H19a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V13A2.124,2.124,0,0,1,18,10.875h2.5a.625.625,0,0,1,0,1.25Z']],
  DesignDocumentIndd: ['design-document-indd', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.456,9.819a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,14.875,12,2.238,2.238,0,0,0,13.456,9.819Z', 'M18.456,9.819a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,19.875,12,2.238,2.238,0,0,0,18.456,9.819Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM5.377,14.375H5.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.126a.249.249,0,0,0,.249-.249V9.877a.252.252,0,0,0-.252-.252H3.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25H5.374a.249.249,0,0,0-.249.249v4.249A.252.252,0,0,0,5.377,14.375ZM11.125,15a.624.624,0,0,1-.481.608.59.59,0,0,1-.144.017.625.625,0,0,1-.559-.346s-1.492-2.974-1.563-3.127-.253-.116-.253.048V15a.625.625,0,0,1-1.25,0V9a.625.625,0,0,1,1.184-.279s1.53,3.049,1.586,3.166a.122.122,0,0,0,.23-.071V9a.625.625,0,0,1,1.25,0Zm1.375.625A.625.625,0,0,1,11.875,15V9a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5,0A.625.625,0,0,1,16.875,15V9a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Z']],
  DesignDocumentMax1: ['design-document-max-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.5,12.125A1.377,1.377,0,0,0,11.125,13.5v1.125a.25.25,0,0,0,.25.25h2.25a.25.25,0,0,0,.25-.25V13.5A1.377,1.377,0,0,0,12.5,12.125Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.125,19.5a.625.625,0,0,1-1.25,0V14.518c0-.112-.141-.088-.185,0l-.631,1.261a.625.625,0,0,1-1.118,0s-.579-1.167-.631-1.261-.185-.094-.185,0V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,1.184-.279l1.217,2.434a.25.25,0,0,0,.448,0l1.217-2.434a.625.625,0,0,1,1.184.279Zm6,0a.625.625,0,0,1-1.25,0V16.375a.25.25,0,0,0-.25-.25h-2.25a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V13.6a2.7,2.7,0,0,1,2.1-2.678A2.63,2.63,0,0,1,15.125,13.5Zm5.934-.279a.625.625,0,1,1-1.118.558l-1.217-2.435a.251.251,0,0,0-.448,0l-1.217,2.435a.625.625,0,1,1-1.118-.558l1.8-3.609a.252.252,0,0,0,0-.224l-1.8-3.609a.625.625,0,1,1,1.118-.558l1.217,2.435a.25.25,0,0,0,.448,0l1.217-2.435a.625.625,0,0,1,1.118.558l-1.8,3.609a.252.252,0,0,0,0,.224Z']],
  DesignDocumentTtf1: ['design-document-ttf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM8.5,12.125H7.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H4.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H13.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H18a.875.875,0,0,0-.875.875v1.625a.25.25,0,0,0,.25.25H19a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V13A2.124,2.124,0,0,1,18,10.875h2.5a.625.625,0,0,1,0,1.25Z']],
  DesignFile3Ds: ['design-file-3ds', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M11.456,13.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,12.875,15.5,2.238,2.238,0,0,0,11.456,13.319Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM8.7,15.647A2.29,2.29,0,0,1,9.125,17,2.014,2.014,0,0,1,7.26,19.121l-.757,0A1.736,1.736,0,0,1,4.875,17.3a.625.625,0,0,1,1.25,0c0,.339.2.575.375.575l.754,0c.337,0,.621-.4.621-.873s-.285-.873-.623-.873a.625.625,0,1,1,0-1.25c.338,0,.623-.4.623-.873s-.284-.872-.621-.873l-.757,0c-.175,0-.372.236-.372.575a.625.625,0,0,1-1.25,0A1.736,1.736,0,0,1,6.5,11.875l.76,0A2.014,2.014,0,0,1,9.125,14,2.3,2.3,0,0,1,8.7,15.354.242.242,0,0,0,8.7,15.647Zm1.8,3.478a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5.927-4.758,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H15.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H16.8a.678.678,0,0,0-.376,1.242Z']],
  DesignFileDxf1: ['design-file-dxf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM2.5,18.125a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm8.559-.9a.625.625,0,1,1-1.118.558s-.858-1.7-.879-1.759-.1-.043-.127.006l-.876,1.753a.625.625,0,1,1-1.118-.558l1.305-2.609a.252.252,0,0,0,0-.224L6.941,11.779a.625.625,0,1,1,1.118-.558s.826,1.644.854,1.709a.1.1,0,0,0,.177-.006l.851-1.7a.625.625,0,1,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm4.441-5.1h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H14.5a.625.625,0,0,1,0,1.25H13.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,13.5,10.875h2a.625.625,0,0,1,0,1.25Z', 'M3.456,12.319a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,4.875,14.5,2.238,2.238,0,0,0,3.456,12.319Z']],
  DesignFileDwg1: ['design-file-dwg-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM2,18.125a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,2,10.875a3.625,3.625,0,0,1,0,7.25Zm9.625-4.861a10.158,10.158,0,0,1-1.065,4.515.625.625,0,0,1-1.166-.128s-.281-1.138-.317-1.265c-.018-.1-.134-.082-.155,0l-.316,1.262a.625.625,0,0,1-.538.47.61.61,0,0,1-.628-.342,10.158,10.158,0,0,1-1.065-4.515V11.5a.625.625,0,0,1,1.25,0v1.764a8.837,8.837,0,0,0,.183,1.783c.024.113.145.066.16.006s.426-1.7.426-1.7a.625.625,0,0,1,1.212,0s.393,1.622.414,1.693.157.121.183-.01a9.2,9.2,0,0,0,.172-1.767V11.5a.625.625,0,0,1,1.25,0Zm5,.236a.625.625,0,0,1-1.25,0V13a.875.875,0,0,0-1.75,0v3a.875.875,0,0,0,1.722.221.076.076,0,0,0-.069-.1H15a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625V16a2.125,2.125,0,0,1-4.25,0V13a2.125,2.125,0,0,1,4.25,0Z', 'M2.956,12.318a.25.25,0,0,0-.331.24v3.883a.25.25,0,0,0,.331.24A2.238,2.238,0,0,0,4.375,14.5,2.239,2.239,0,0,0,2.956,12.318Z']],
  DesignFilePsd: ['design-file-psd', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M7,13H6.25a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H7a1,1,0,0,0,0-2Z', 'M16.317,13.137a.248.248,0,0,0-.317.242v4.242a.248.248,0,0,0,.317.242,2.5,2.5,0,0,0,0-4.726Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM8.972,14.338A2.079,2.079,0,0,1,6.888,16H6.25a.25.25,0,0,0-.25.25V18.5a.5.5,0,0,1-1,0v-6a.5.5,0,0,1,.5-.5H7A2,2,0,0,1,8.972,14.338Zm2.385.133L13.2,15.7a1.8,1.8,0,0,1-1,3.3H10.5a.5.5,0,0,1,0-1h1.7a.8.8,0,0,0,.446-1.471L10.8,15.3a1.8,1.8,0,0,1,1-3.3h1.7a.5.5,0,0,1,0,1H11.8a.8.8,0,0,0-.446,1.471ZM15.5,19a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5,3.5,3.5,0,0,1,0,7Z']],
  DesignFileOtf: ['design-file-otf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M7,13.125A.877.877,0,0,0,6.125,14v3a.875.875,0,0,0,1.75,0V14A.877.877,0,0,0,7,13.125Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM9.125,17a2.125,2.125,0,0,1-4.25,0V14a2.125,2.125,0,0,1,4.25,0ZM14.5,13.125H13.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V13.375a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H18.5a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,17.5,11.875h2a.625.625,0,0,1,0,1.25Z']],
  DesignFileOtf1: ['design-file-otf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M3.5,12.125A.877.877,0,0,0,2.625,13v3a.875.875,0,0,0,1.75,0V13A.877.877,0,0,0,3.5,12.125Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM5.625,16a2.125,2.125,0,0,1-4.25,0V13a2.125,2.125,0,0,1,4.25,0ZM11,12.125H9.875a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H7a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0H14a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H15a.625.625,0,0,1,0,1.25H13.875a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,14,10.875h2a.625.625,0,0,1,0,1.25Z']],
  DesignFileText: ['design-file-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.914,17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.914ZM16.75,13a.75.75,0,0,1-1.5,0V12a.25.25,0,0,0-.25-.25H13a.25.25,0,0,0-.25.25v6.5a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5H10a.75.75,0,0,1,0-1.5h1a.25.25,0,0,0,.25-.25V12a.25.25,0,0,0-.25-.25H9a.25.25,0,0,0-.25.25v1a.75.75,0,0,1-1.5,0V11.5A1.25,1.25,0,0,1,8.5,10.25h7a1.25,1.25,0,0,1,1.25,1.25Z']],
  DesignFileTextImage: ['design-file-text-image', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.914,17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.914ZM8.6,4.5A1.5,1.5,0,1,1,7.1,6,1.5,1.5,0,0,1,8.6,4.5ZM7.076,12.737l1.478-2.388a1,1,0,0,1,1.273-.206l1.579,1.206a.249.249,0,0,0,.349-.045L13.266,9.36a1,1,0,0,1,1.587.067L16.3,12.8a.5.5,0,0,1-.46.7H7.5A.5.5,0,0,1,7.076,12.737ZM16.5,20.75H6.5a.75.75,0,0,1,0-1.5h10a.75.75,0,0,1,0,1.5Zm0-3.5H6.5a.75.75,0,0,1,0-1.5h10a.75.75,0,0,1,0,1.5Z']],
  DesignFileTtf1: ['design-file-ttf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM5.5,12.125H4.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H1.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H10.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V12.375a.25.25,0,0,0-.25-.25H7.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H15.5a.625.625,0,0,1,0,1.25H14.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,14.5,10.875h2a.625.625,0,0,1,0,1.25Z']],
  DesignFileVector: ['design-file-vector', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.414,4.914,17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.914ZM7.5,20h0a2,2,0,0,1,0-4c.272,0,.658.266.956-.032l4.525-4.526c.192-.192.019-.671.019-.943a2,2,0,1,1,2,2h0c-.281,0-.806-.149-.955,0l-4.47,4.471c-.306.306-.075.749-.075,1.03A2,2,0,0,1,7.5,20Zm9.417-4.251H15.749a2.585,2.585,0,0,0-2.582,2.582V20a.75.75,0,0,1-1.5,0V18.332a4.086,4.086,0,0,1,4.082-4.082h1.168a.75.75,0,0,1,0,1.5Z']],
  DesignFilePyramid: ['design-file-pyramid', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,6.329a2,2,0,0,0-.586-1.415L17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2Zm-10.133.735a.249.249,0,0,1,.458,0l3.661,8.54a.245.245,0,0,1-.317.328,9.447,9.447,0,0,0-3.625-.648,9.438,9.438,0,0,0-3.617.645.245.245,0,0,1-.316-.33Zm.177,12.706c-2.6,0-4.544-.92-4.544-1.743s1.943-1.741,4.544-1.741,4.544.919,4.544,1.741S14.645,19.77,12.044,19.77Z']],
  DesignFileSelect: ['design-file-select', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.934,12.349a.894.894,0,0,1-.286-.288A.1.1,0,0,0,14.553,12H9.459a.12.12,0,0,0-.1.051.928.928,0,0,1-.289.3c-.023.014-.07.037-.07.091v4.621a.109.109,0,0,0,.053.084.894.894,0,0,1,.291.283c.016.024.032.074.1.074h5.126c.055,0,.07-.042.083-.062a.911.911,0,0,1,.3-.293A.088.088,0,0,0,15,17.056V12.447A.119.119,0,0,0,14.934,12.349Z', 'M21.414,4.914,17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.914ZM18,11.583a.918.918,0,0,1-.917.917.107.107,0,0,0-.083.118v4.258c0,.123.083.124.083.124a.918.918,0,0,1,.917.917v1.666a.918.918,0,0,1-.917.917H15.417a.918.918,0,0,1-.917-.917s.006-.083-.112-.083H9.606c-.122,0-.106.083-.106.083a.918.918,0,0,1-.917.917H6.917A.918.918,0,0,1,6,19.583V17.917A.918.918,0,0,1,6.917,17S7,16.988,7,16.853V12.635c0-.136-.083-.135-.083-.135A.918.918,0,0,1,6,11.583V9.917A.918.918,0,0,1,6.917,9H8.583a.918.918,0,0,1,.917.917S9.488,10,9.588,10h4.818a.085.085,0,0,0,.094-.083A.918.918,0,0,1,15.417,9h1.666A.918.918,0,0,1,18,9.917Z']],
  DesignFileTtf: ['design-file-ttf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM8.5,13.125H7.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V13.375a.25.25,0,0,0-.25-.25H4.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H13.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V13.375a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H18.5a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,17.5,11.875h2a.625.625,0,0,1,0,1.25Z']],
  DesignFileSelectAlternate: ['design-file-select-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.083,7H15.417a.918.918,0,0,0-.917.917A.085.085,0,0,1,14.406,8H9.588c-.1,0-.088-.083-.088-.083A.918.918,0,0,0,8.583,7H6.917A.918.918,0,0,0,6,7.917V9.583a.918.918,0,0,0,.917.917S7,10.5,7,10.635v4.218c0,.135-.083.147-.083.147A.918.918,0,0,0,6,15.917v1.666a.918.918,0,0,0,.917.917H8.583a.918.918,0,0,0,.917-.917s-.016-.083.106-.083h4.782c.118,0,.112.083.112.083a.918.918,0,0,0,.917.917h1.666A.918.918,0,0,0,18,17.583V15.917A.918.918,0,0,0,17.083,15S17,15,17,14.876V10.618a.107.107,0,0,1,.083-.118A.918.918,0,0,0,18,9.583V7.917A.918.918,0,0,0,17.083,7ZM15,15.056a.086.086,0,0,1-.056.089.9.9,0,0,0-.3.294c-.013.019-.028.061-.083.061H9.439c-.063,0-.079-.05-.1-.074a.9.9,0,0,0-.291-.283A.109.109,0,0,1,9,15.059v-4.62a.11.11,0,0,1,.07-.092.918.918,0,0,0,.289-.3.12.12,0,0,1,.1-.051h5.094a.094.094,0,0,1,.094.061.907.907,0,0,0,.287.288.121.121,0,0,1,.066.1Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.536A.5.5,0,0,1,20,7.035Z']],
  DesignDocument3Ds1: ['design-document-3ds-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9.085,17.966a2.707,2.707,0,0,1-2.7,2.159H3.5a.625.625,0,0,1,0-1.25h3a1.375,1.375,0,0,0,0-2.75H5a.625.625,0,0,1,0-1.25H6.5a1.375,1.375,0,0,0,0-2.75h-3a.625.625,0,0,1,0-1.25H6.382a2.707,2.707,0,0,1,2.7,2.159,2.624,2.624,0,0,1-.7,2.292.244.244,0,0,0,0,.348A2.624,2.624,0,0,1,9.085,17.966ZM10.5,20.125a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25Zm7.305-5.671,1.95.974a2.48,2.48,0,0,1-1.109,4.7H16.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.549-2.329l-1.949-.974a2.479,2.479,0,0,1,1.108-4.7H20.5a.625.625,0,0,1,0,1.25H18.354a1.229,1.229,0,0,0-.549,2.329Z', 'M11.125,12.5V18.5a.252.252,0,0,0,.312.246,3.376,3.376,0,0,0,0-6.486A.252.252,0,0,0,11.125,12.5Z']],
  DesignDocumentPsd: ['design-document-psd', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,9.625H6.375a.25.25,0,0,0-.25.25v1.25a.25.25,0,0,0,.25.25H7a.875.875,0,0,0,0-1.75Z', 'M16.125,10.059v3.882a.249.249,0,0,0,.331.24A2.237,2.237,0,0,0,17.875,12a2.237,2.237,0,0,0-1.419-2.181A.249.249,0,0,0,16.125,10.059Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.875,12.625h-.5a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9A.625.625,0,0,1,5.5,8.375H7a2.128,2.128,0,0,1,2.114,2.347A2.213,2.213,0,0,1,6.875,12.625Zm4.552-1.758,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H10.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,11.8,8.375h1.7a.625.625,0,0,1,0,1.25H11.8a.678.678,0,0,0-.376,1.242ZM15.5,15.625A.625.625,0,0,1,14.875,15V9a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Z']],
  DesignDocumentPsd1: ['design-document-psd-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.125,12.5V18.5a.252.252,0,0,0,.312.246,3.376,3.376,0,0,0,0-6.486A.252.252,0,0,0,17.125,12.5Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM6.4,16.125H5.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0v-8a.625.625,0,0,1,.625-.625h2a2.629,2.629,0,0,1,2.574,3.149A2.7,2.7,0,0,1,6.4,16.125Zm5.409-1.671,1.95.974a2.48,2.48,0,0,1-1.109,4.7H10.5a.625.625,0,0,1,0-1.25h2.146a1.229,1.229,0,0,0,.549-2.329l-1.949-.974a2.479,2.479,0,0,1,1.108-4.7H14.5a.625.625,0,0,1,0,1.25H12.354a1.229,1.229,0,0,0-.549,2.329Zm4.7,5.671a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25Z', 'M6.5,12.125H5.375a.25.25,0,0,0-.25.25v2.25a.25.25,0,0,0,.25.25H6.5a1.375,1.375,0,0,0,0-2.75Z']],
  DesignFilePen: ['design-file-pen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.458,14.7a1.5,1.5,0,1,0,2.122,0A1.5,1.5,0,0,0,9.458,14.7Z', 'M21.414,4.914,17.086.586A2,2,0,0,0,15.672,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.329A2,2,0,0,0,21.414,4.914ZM11.355,19.406,6.931,20.76a1.123,1.123,0,0,1-1.409-1.414l1.353-4.42a5.5,5.5,0,0,1,4.54-3.822.249.249,0,0,1,.27.186,4.707,4.707,0,0,0,3.306,3.3.252.252,0,0,1,.187.271A5.5,5.5,0,0,1,11.355,19.406Zm7.28-7.086a3.305,3.305,0,0,1-4.674-4.674.5.5,0,0,1,.707,0l3.967,3.967a.5.5,0,0,1,0,.707Z']],
  DesignFileDwg: ['design-file-dwg', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M5.956,13.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,7.375,15.5,2.238,2.238,0,0,0,5.956,13.319Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM5,19.125a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,5,11.875a3.625,3.625,0,0,1,0,7.25Zm9.625-4.861a10.155,10.155,0,0,1-1.065,4.515.627.627,0,0,1-.56.346.527.527,0,0,1-.068,0,.624.624,0,0,1-.538-.47s-.281-1.137-.317-1.265c-.018-.1-.134-.081-.155,0s-.316,1.262-.316,1.262a.624.624,0,0,1-.538.47.609.609,0,0,1-.628-.342,10.155,10.155,0,0,1-1.065-4.515V12.5a.625.625,0,0,1,1.25,0v1.764a8.847,8.847,0,0,0,.183,1.784c.024.113.145.065.16.006s.426-1.7.426-1.7a.624.624,0,0,1,1.212,0s.393,1.622.414,1.693.157.12.183-.011a9.2,9.2,0,0,0,.172-1.767V12.5a.625.625,0,0,1,1.25,0Zm5,.236a.625.625,0,0,1-1.25,0V14a.875.875,0,0,0-1.75,0v3a.875.875,0,0,0,1.722.221.076.076,0,0,0-.069-.1H18a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625V17a2.125,2.125,0,0,1-4.25,0V14a2.125,2.125,0,0,1,4.25,0Z']],
  DesignFileMax1: ['design-file-max-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M9,12.125A.877.877,0,0,0,8.125,13v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V13A.877.877,0,0,0,9,12.125Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM6.125,17.5a.625.625,0,0,1-1.25,0V14.325c0-.075-.08-.063-.109,0s-.207.457-.207.457a.65.65,0,0,1-1.118,0s-.167-.327-.2-.4-.118-.062-.118.009V17.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.807,1.606.837,1.673a.124.124,0,0,0,.208,0c.041-.083.837-1.674.837-1.674a.625.625,0,0,1,1.184.279Zm5,0a.625.625,0,0,1-1.25,0V15.375a.25.25,0,0,0-.25-.25H8.375a.25.25,0,0,0-.25.25V17.5a.625.625,0,0,1-1.25,0V13.125a2.212,2.212,0,0,1,1.9-2.239A2.128,2.128,0,0,1,11.125,13Zm4.934-.279a.625.625,0,1,1-1.118.558s-.839-1.68-.876-1.753a.069.069,0,0,0-.129,0l-.877,1.754a.625.625,0,1,1-1.118-.558l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.851,1.7.876,1.753a.07.07,0,0,0,.129,0l.877-1.754a.625.625,0,1,1,1.118.558l-1.305,2.609a.252.252,0,0,0,0,.224Z']],
  DesignFileIndd: ['design-file-indd', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.5,6h3.9a.25.25,0,0,0,.177-.427L14.427.427A.25.25,0,0,0,14,.6V4.5A1.5,1.5,0,0,0,15.5,6Z', 'M19.456,13.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,20.875,15.5,2.238,2.238,0,0,0,19.456,13.319Z', 'M14.456,13.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,15.875,15.5,2.238,2.238,0,0,0,14.456,13.319Z', 'M22.8,10H3.25A.25.25,0,0,1,3,9.75v-1a.25.25,0,0,1,.25-.25h16.5A.25.25,0,0,0,20,8.25v-1A.25.25,0,0,0,19.75,7H15.5A2.5,2.5,0,0,1,13,4.5V.25A.25.25,0,0,0,12.75,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H18a1.993,1.993,0,0,0,1.894-1.38.1.1,0,0,0-.11-.12H3.25A.25.25,0,0,1,3,22.25v-1A.25.25,0,0,1,3.25,21H22.8A1.114,1.114,0,0,0,24,20V11A1.114,1.114,0,0,0,22.8,10ZM6.377,17.875H6.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.126a.249.249,0,0,0,.249-.249V13.377a.252.252,0,0,0-.252-.252H4.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25H6.374a.249.249,0,0,0-.249.249v4.249A.252.252,0,0,0,6.377,17.875Zm5.748.625a.624.624,0,0,1-.481.608.59.59,0,0,1-.144.017.625.625,0,0,1-.559-.346s-1.492-2.974-1.563-3.127-.253-.116-.253.048v2.8a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s1.53,3.049,1.586,3.166a.122.122,0,0,0,.23-.071V12.5a.625.625,0,0,1,1.25,0Zm1.375.625a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5,0a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Z']],
  DesignFileMax: ['design-file-max', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M12,13.125a.877.877,0,0,0-.875.875v.625a.25.25,0,0,0,.25.25h1.25a.25.25,0,0,0,.25-.25V14A.877.877,0,0,0,12,13.125Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM9.125,18.5a.625.625,0,0,1-1.25,0V15.325c0-.075-.08-.062-.109,0s-.207.457-.207.457a.65.65,0,0,1-1.118,0s-.167-.327-.2-.4-.118-.062-.118.009V18.5a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s.807,1.606.837,1.673a.124.124,0,0,0,.208,0l.837-1.674a.625.625,0,0,1,1.184.279Zm5,0a.625.625,0,0,1-1.25,0V16.375a.25.25,0,0,0-.25-.25h-1.25a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0V14.125a2.211,2.211,0,0,1,1.9-2.238A2.127,2.127,0,0,1,14.125,14Zm4.934-.279a.625.625,0,1,1-1.118.558s-.839-1.68-.876-1.753a.069.069,0,0,0-.129,0l-.877,1.754a.625.625,0,1,1-1.118-.558l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,1,1,1.118-.558s.851,1.7.876,1.753a.07.07,0,0,0,.129,0l.877-1.754a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Z']],
  DesignDocumentDwg: ['design-document-dwg', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,4.5H2A1.5,1.5,0,0,0,.5,6V18A1.5,1.5,0,0,0,2,19.5H22A1.5,1.5,0,0,0,23.5,18V6A1.5,1.5,0,0,0,22,4.5ZM5,16.125a.625.625,0,0,1-.625-.625v-6A.625.625,0,0,1,5,8.875a3.625,3.625,0,0,1,0,7.25Zm9.625-4.861a10.158,10.158,0,0,1-1.065,4.515.629.629,0,0,1-.56.346.527.527,0,0,1-.068,0,.625.625,0,0,1-.538-.47s-.281-1.138-.317-1.265c-.018-.1-.134-.082-.155,0l-.316,1.262a.625.625,0,0,1-.538.47.61.61,0,0,1-.628-.342,10.158,10.158,0,0,1-1.065-4.515V9.5a.625.625,0,0,1,1.25,0v1.764a8.837,8.837,0,0,0,.183,1.783c.023.113.145.066.16.006l.426-1.7a.625.625,0,0,1,1.212,0s.393,1.622.414,1.693.157.121.183-.01a9.2,9.2,0,0,0,.172-1.767V9.5a.625.625,0,0,1,1.25,0Zm5,.236a.625.625,0,0,1-1.25,0V11a.875.875,0,0,0-1.75,0v3a.875.875,0,0,0,1.722.221.076.076,0,0,0-.069-.1H18a.625.625,0,0,1,0-1.25h1a.625.625,0,0,1,.625.625V14a2.125,2.125,0,0,1-4.25,0V11a2.125,2.125,0,0,1,4.25,0Z', 'M5.956,10.318a.25.25,0,0,0-.331.24v3.883a.25.25,0,0,0,.331.24A2.238,2.238,0,0,0,7.375,12.5,2.239,2.239,0,0,0,5.956,10.318Z']],
  DesignFileTextImageAlternate: ['design-file-text-image-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,13h8.343a.5.5,0,0,0,.46-.7L15.353,8.927a1,1,0,0,0-1.587-.067L12.255,10.8a.25.25,0,0,1-.349.046L10.327,9.643a1,1,0,0,0-1.273.207L7.576,12.237A.5.5,0,0,0,8,13Z', 'M7.603 5.500 A1.500 1.500 0 1 0 10.603 5.500 A1.500 1.500 0 1 0 7.603 5.500 Z', 'M17,14.5H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z', 'M17,17.5H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z', 'M21.707,5.707,16.293.293A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.414A1,1,0,0,0,21.707,5.707ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.536A.5.5,0,0,1,20,7.035Z']],
  DesignDocument3Ds: ['design-document-3ds', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.125,10.059v3.882a.249.249,0,0,0,.331.24A2.237,2.237,0,0,0,12.875,12a2.237,2.237,0,0,0-1.419-2.181A.249.249,0,0,0,11.125,10.059Z', 'M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5Zm-13.375,9A2.014,2.014,0,0,1,7.26,15.621l-.757,0A1.736,1.736,0,0,1,4.875,13.8a.625.625,0,0,1,1.25,0c0,.339.2.575.375.575l.754,0c.337,0,.621-.4.621-.873s-.285-.873-.623-.873a.625.625,0,1,1,0-1.25c.338,0,.623-.4.623-.873s-.284-.872-.621-.873l-.757,0c-.175,0-.372.236-.372.575a.625.625,0,0,1-1.25,0A1.736,1.736,0,0,1,6.5,8.375l.76,0A2.014,2.014,0,0,1,9.125,10.5,2.29,2.29,0,0,1,8.7,11.853a.243.243,0,0,0,0,.294A2.29,2.29,0,0,1,9.125,13.5ZM10.5,15.625A.625.625,0,0,1,9.875,15V9a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5.927-4.758,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H15.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226A1.928,1.928,0,0,1,16.8,8.375h1.7a.625.625,0,0,1,0,1.25H16.8a.678.678,0,0,0-.376,1.242Z']],
  DesignDocumentTtf: ['design-document-ttf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM8.5,9.625H7.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9.875a.25.25,0,0,0-.25-.25H4.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm6,0H13.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V9.875a.25.25,0,0,0-.25-.25H10.5a.625.625,0,0,1,0-1.25h4a.625.625,0,0,1,0,1.25Zm5,0h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H18.5a.625.625,0,0,1,0,1.25H17.375a.25.25,0,0,0-.25.25V15a.625.625,0,0,1-1.25,0V10A1.626,1.626,0,0,1,17.5,8.375h2a.625.625,0,0,1,0,1.25Z']],
  DesignDocumentDxf1: ['design-document-dxf-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.125,12.5V18.5a.252.252,0,0,0,.312.246,3.376,3.376,0,0,0,0-6.486A.252.252,0,0,0,5.125,12.5Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM4.5,20.125a.625.625,0,0,1-.625-.625v-8a.625.625,0,0,1,.625-.625,4.625,4.625,0,0,1,0,9.25Zm10-8H12a.875.875,0,0,0-.875.875v1.625a.25.25,0,0,0,.25.25H13a.625.625,0,0,1,0,1.25H11.375a.25.25,0,0,0-.25.25V19.5a.625.625,0,0,1-1.25,0V13A2.124,2.124,0,0,1,12,10.875h2.5a.625.625,0,0,1,0,1.25Zm6.559,7.1a.625.625,0,1,1-1.118.558l-1.217-2.435a.25.25,0,0,0-.448,0l-1.217,2.435a.625.625,0,1,1-1.118-.558l1.8-3.609a.252.252,0,0,0,0-.224l-1.8-3.609a.625.625,0,1,1,1.118-.558l1.217,2.435a.25.25,0,0,0,.448,0l1.217-2.435a.625.625,0,0,1,1.118.558l-1.8,3.609a.252.252,0,0,0,0,.224Z']],
  DesignDocumentIndd1: ['design-document-indd-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.456,13.819a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,19.875,16,2.238,2.238,0,0,0,18.456,13.819Z', 'M13.456,13.819a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,14.875,16,2.238,2.238,0,0,0,13.456,13.819Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM5.377,18.375H5.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.126a.249.249,0,0,0,.249-.249V13.877a.252.252,0,0,0-.252-.252H3.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25H5.374a.249.249,0,0,0-.249.249v4.249A.252.252,0,0,0,5.377,18.375ZM11.125,19a.624.624,0,0,1-.481.608.59.59,0,0,1-.144.017.625.625,0,0,1-.559-.346s-1.492-2.974-1.563-3.127-.253-.116-.253.048V19a.625.625,0,0,1-1.25,0V13a.625.625,0,0,1,1.184-.279s1.53,3.049,1.586,3.166a.122.122,0,0,0,.23-.071V13a.625.625,0,0,1,1.25,0Zm1.375.625A.625.625,0,0,1,11.875,19V13a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5,0A.625.625,0,0,1,16.875,19V13a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Z']],
  DesignFile3Ds1: ['design-file-3ds-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M8.456,12.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,9.875,14.5,2.238,2.238,0,0,0,8.456,12.319Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM5.7,14.647A2.29,2.29,0,0,1,6.125,16,2.014,2.014,0,0,1,4.26,18.121l-.757,0A1.736,1.736,0,0,1,1.875,16.3a.625.625,0,0,1,1.25,0c0,.339.2.575.375.575l.754,0c.337,0,.621-.4.621-.873s-.285-.873-.623-.873a.625.625,0,1,1,0-1.25c.338,0,.623-.4.623-.873s-.284-.872-.621-.873l-.757,0c-.175,0-.372.236-.372.575a.625.625,0,0,1-1.25,0A1.736,1.736,0,0,1,3.5,10.875l.76,0A2.014,2.014,0,0,1,6.125,13,2.3,2.3,0,0,1,5.7,14.354.242.242,0,0,0,5.7,14.647Zm1.8,3.478a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5.927-4.758,1.84,1.226a1.928,1.928,0,0,1-1.07,3.532H12.5a.625.625,0,0,1,0-1.25h1.7a.678.678,0,0,0,.376-1.242l-1.84-1.226a1.928,1.928,0,0,1,1.07-3.532h1.7a.625.625,0,0,1,0,1.25H13.8a.678.678,0,0,0-.376,1.242Z']],
  DesignFilePsd1: ['design-file-psd-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,5.708,18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6.414A1,1,0,0,0,23.707,5.708Z', 'M13.317,12.137a.248.248,0,0,0-.317.242v4.242a.248.248,0,0,0,.317.242,2.5,2.5,0,0,0,0-4.726Z', 'M4,12H3.25a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H4a1,1,0,0,0,0-2Z', 'M18,19V10a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H17A1,1,0,0,0,18,19ZM5.972,13.338A2.079,2.079,0,0,1,3.888,15H3.25a.25.25,0,0,0-.25.25V17.5a.5.5,0,0,1-1,0v-6a.5.5,0,0,1,.5-.5H4A2,2,0,0,1,5.972,13.338Zm2.385.133L10.2,14.7a1.8,1.8,0,0,1-1,3.3H7.5a.5.5,0,0,1,0-1H9.2a.8.8,0,0,0,.446-1.471L7.8,14.3a1.8,1.8,0,0,1,1-3.3h1.7a.5.5,0,0,1,0,1H8.8a.8.8,0,0,0-.446,1.471ZM12.5,18a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5,3.5,3.5,0,0,1,0,7Z']],
  DesignFileDxf: ['design-file-dxf', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,6h3.9a.25.25,0,0,0,.177-.427L16.427.427A.25.25,0,0,0,16,.6V4.5A1.5,1.5,0,0,0,17.5,6Z', 'M6.456,13.319a.249.249,0,0,0-.331.24v3.882a.25.25,0,0,0,.331.241A2.239,2.239,0,0,0,7.875,15.5,2.238,2.238,0,0,0,6.456,13.319Z', 'M21.75,7H17.5A2.5,2.5,0,0,1,15,4.5V.25A.25.25,0,0,0,14.75,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7.25A.25.25,0,0,0,21.75,7ZM5.5,19.125a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm8.559-.9a.625.625,0,1,1-1.118.558s-.859-1.7-.879-1.759-.1-.043-.127.007-.876,1.752-.876,1.752a.625.625,0,1,1-1.118-.558l1.3-2.609a.252.252,0,0,0,0-.224l-1.3-2.609a.625.625,0,0,1,1.118-.558s.826,1.645.854,1.709a.1.1,0,0,0,.177-.006l.851-1.7a.625.625,0,0,1,1.118.558l-1.3,2.609a.252.252,0,0,0,0,.224Zm4.441-5.1h-2a.375.375,0,0,0-.375.375v1.125a.25.25,0,0,0,.25.25H17.5a.625.625,0,0,1,0,1.25H16.375a.25.25,0,0,0-.25.25V18.5a.625.625,0,0,1-1.25,0v-5A1.626,1.626,0,0,1,16.5,11.875h2a.625.625,0,0,1,0,1.25Z']],
  DesignFileIndd1: ['design-file-indd-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.456,12.319a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,19.875,14.5,2.238,2.238,0,0,0,18.456,12.319Z', 'M13.456,12.319a.249.249,0,0,0-.331.24v3.882a.249.249,0,0,0,.331.24A2.238,2.238,0,0,0,14.875,14.5,2.238,2.238,0,0,0,13.456,12.319Z', 'M24,6.415a1,1,0,0,0-.293-.708L18.293.293A1,1,0,0,0,17.586,0H6A2,2,0,0,0,4,2V7.75A.25.25,0,0,0,4.25,8h1.5A.25.25,0,0,0,6,7.75V2.5A.5.5,0,0,1,6.5,2H16.75a.25.25,0,0,1,.25.25V5a2,2,0,0,0,2,2h2.75a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H1.2A1.114,1.114,0,0,0,0,10v9a1.114,1.114,0,0,0,1.2,1H21.75a.25.25,0,0,1,.25.25V21.5a.5.5,0,0,1-.5.5H6.25A.25.25,0,0,1,6,21.75v-.5A.25.25,0,0,0,5.75,21H4.25a.25.25,0,0,0-.25.25V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM5.377,16.875H5.5a.625.625,0,0,1,0,1.25h-2a.625.625,0,0,1,0-1.25h.126a.249.249,0,0,0,.249-.249V12.377a.252.252,0,0,0-.252-.252H3.5a.625.625,0,0,1,0-1.25h2a.625.625,0,0,1,0,1.25H5.374a.249.249,0,0,0-.249.249v4.249A.252.252,0,0,0,5.377,16.875Zm5.748.625a.624.624,0,0,1-.481.608.59.59,0,0,1-.144.017.625.625,0,0,1-.559-.346s-1.492-2.974-1.563-3.127-.253-.116-.253.048v2.8a.625.625,0,0,1-1.25,0v-6a.625.625,0,0,1,1.184-.279s1.53,3.049,1.586,3.166a.122.122,0,0,0,.23-.071V11.5a.625.625,0,0,1,1.25,0Zm1.375.625a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Zm5,0a.625.625,0,0,1-.625-.625v-6a.625.625,0,0,1,.625-.625,3.625,3.625,0,0,1,0,7.25Z']]
};
exports["default"] = _default;